import React, {Component} from 'react';
import cx from 'classnames';
import update from 'immutability-helper';
import _ from 'lodash';

import I18n from 'app/common/i18n';
import {history} from 'store';
import * as cookie from 'app/utils/cookie';
import * as routePath from 'app/utils/routePath';

import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';

import NavMenu from './NavMenu';
import Logo from 'app/assets/Logo-Horizondal.svg';
import AdminIcon from 'app/assets/filter.svg';
import SettingsIcon from 'app/assets/settings.svg';

export default class Header extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showSettingsSubmenu: false
    }
  }

  handleChangePassword() {
    history.push(routePath.changePasswordRoute);
  }

  handleLogout() {
    this.props.logoutUser();
  }

  getSettingsSubmenuRedirectLinks() {

    let menuActions = {
      changePassword: _.debounce(() => this.handleChangePassword(), 200),

      logout: _.debounce(() => this.handleLogout(), 200)
    }

    return menuActions
    }


  toggleSettingsSubmenu(status) {
    let newState = update(this.state, { showSettingsSubmenu: { $set: status } })
    this.setState(newState)
  }

  render() {
    let {currentPath} = this.props;
    return (
      <div className='clearfix header flex justify-between items-center'>
        <div className='col-5 m1 clickable flex items-center'>
          <div onClick={() => history.push(routePath.dashboardRoute)}>
            <Logo className='svg-icon svg-logo-3x flex items-center'/>
          </div>
        </div>
        <div className='clearfix col-6 m1 flex justify-end items-center'>
          <div className={cx('clickable center m2 nav-menu flex items-center', {active: currentPath === routePath.candidatesRoute})}
            onClick={() => history.push(routePath.candidatesRoute)}>
            <AdminIcon className='svg-icon svg-1x' />
            <div className='menu-text'>{I18n.t('nav_menu.filter_candidates')}</div>
          </div>
          <div className={cx('clearfix nav-menu', {
          // active: (currentPath === routePath.workOrdersRoute || currentPath === routePath.workOrdersPastRoute)
            })}
            style={{ 'text-align': 'center' }}
            title={I18n.t('nav_menu.settings')}>
            <NavMenu
              display={this.state.showSettingsSubmenu} displayHandler={(status) => this.toggleSettingsSubmenu(status)}
              navElement={<SettingsIcon className='svg-icon svg-1x'/>}
              menuTitle={
                <div className=''>
                  {I18n.t('nav_menu.settings')}
                </div>}
              submenu={I18n.t('nav_menu.user_settings_submenu')}
              redirectLinks={this.getSettingsSubmenuRedirectLinks()}/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/views/Header.js